module.exports = __webpack_public_path__ + "public/img/jingyuetang_qr.4b6c3817.png";